import { MonthYear } from '@common/types';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/Projects/Domain/commands-core';
import { Component } from 'vue-facing-decorator';

@Component
export default class ProjectsCommands extends VueCqrs 
{
	invokeUpdateProjectActivePlanCommandV1(workspaceId: number, portfolioId: string, projectId: string, oldActivePlanId: string, newActivePlanId: string)
	{
		const cmd = new c.UpdateProjectActivePlanCommandV1(workspaceId, portfolioId, projectId, oldActivePlanId, newActivePlanId);
		this.$command(cmd, newActivePlanId);
	}

	invokeCreateProjectPlanCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		planId: string, planName: string, durationInMonths: number, granularity: string, denomination: string, planningHorizonInYears: number, submissionDueDateIsoString: string | null)
	{
		const cmd = new c.CreateProjectPlanCommandV1(workspaceId, portfolioId, projectId, activePlanId,
			planId, planName, durationInMonths, granularity, denomination, planningHorizonInYears, submissionDueDateIsoString);

		this.$command(cmd, projectId);
	}

	invokeCloneProjectPlanCommandV1(workspaceId: number, portfolioId: string, projectId: string, sourcePlanId: string, clonePlanId: string, clonePlanName: string)
	{
		const cmd = new c.CloneProjectPlanCommandV1(workspaceId, portfolioId, projectId, sourcePlanId, clonePlanId, clonePlanName);
		this.$command(cmd, clonePlanId);
	}

	invokeDeleteProjectPlanCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, planId: string)
	{
		const cmd = new c.DeleteProjectPlanCommandV1(workspaceId, portfolioId, projectId, activePlanId, planId);
		this.$command(cmd, planId);
	}

	invokeExportProjectPlanCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string)
	{
		const cmd = new c.ExportProjectPlanCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId);
		this.$command(cmd, projectPlanId);
	}

	invokeUpdateProjectPlanCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, planId: string, planName: string,
		durationInMonths: number, granularity: string, denomination: string, planningHorizonInYears: number, submissionDueDateIsoString: string | null)
	{
		const cmd = new c.UpdateProjectPlanCommandV1(workspaceId, portfolioId, projectId, activePlanId, planId, planName, durationInMonths, granularity, denomination, planningHorizonInYears, submissionDueDateIsoString);
		this.$command(cmd, projectId);
	}

	invokeSubmitProjectPlanCommandV1(workspaceId: number, portfolioId: string, projectId: string, planId: string)
	{
		const cmd = new c.SubmitProjectPlanCommandV1(workspaceId, portfolioId, projectId, planId);
		this.$command(cmd, planId);
	}

	invokeUnsubmitProjectPlanCommandV1(workspaceId: number, portfolioId: string, projectId: string, planId: string)
	{
		const cmd = new c.UnsubmitProjectPlanCommandV1(workspaceId, portfolioId, projectId, planId);
		this.$command(cmd, planId);
	}


	invokeUpdateBenefitsConfidenceFactorCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, planId: string, benefitsConfidenceFactor: number | null)
	{
		const cmd = new c.UpdateBenefitsConfidenceFactorCommandV1(workspaceId, portfolioId, projectId, activePlanId, planId, benefitsConfidenceFactor);
		this.$command(cmd, projectId);
	}


	invokeUpdateProjectRevenuesCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, granularity: string, denomination: string, entries: string[], comment: string | null)
	{
		const cmd = new c.UpdateProjectRevenuesCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId, granularity, denomination, entries, comment);
		this.$command(cmd, projectId);
	}

	invokeUpdateProjectMarginsCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, granularity: string, entries: string[], comment: string | null)
	{
		const cmd = new c.UpdateProjectMarginsCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId, granularity, entries, comment);
		this.$command(cmd, projectId);
	}

	invokeUpdateProjectResourceSavingsCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, granularity: string, entries: string[], comment: string | null)
	{
		const cmd = new c.UpdateProjectResourceSavingsCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId, granularity, entries, comment);
		this.$command(cmd, projectId);
	}

	invokeUpdateProjectExpenseAllocationsCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, granularity: string, denomination: string, entries: string[], comment: string | null)
	{
		const cmd = new c.UpdateProjectExpenseAllocationsCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId, granularity, denomination, entries, comment);
		this.$command(cmd, projectId);
	}

	invokeUpdateProjectExpenseSavingsCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, granularity: string, denomination: string, entries: string[], comment: string | null)
	{
		const cmd = new c.UpdateProjectExpenseSavingsCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId, granularity, denomination, entries, comment);
		this.$command(cmd, projectId);
	}

	invokeUpdateProjectResourceAllocationsCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, granularity: string, entries: string[], comment: string | null)
	{
		const cmd = new c.UpdateProjectResourceAllocationsCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId, granularity, entries, comment);
		this.$command(cmd, projectId);
	}

	invokeUpdateProjectResourceUnitCostsCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, fromYear: number, entries: string[], comment: string | null)
	{
		const cmd = new c.UpdateProjectResourceUnitCostsCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId, fromYear, entries, comment);
		this.$command(cmd, projectId);
	}

	invokeCreateProjectCapexItemCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, capexAccountId: string, itemId: string, name: string, cost: number, acquisitionMonthIndex: number, salvageValue: number, usefulLifeInYears: number, depreciationMethod: string, denomination: string)
	{
		const cmd = new c.CreateProjectCapexItemCommandV1(workspaceId, portfolioId, projectId, activePlanId,
			projectPlanId, capexAccountId, itemId, name, cost, acquisitionMonthIndex, salvageValue, usefulLifeInYears, depreciationMethod, denomination);

		this.$command(cmd, projectId);
	}

	invokeDeleteProjectCapexItemCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string, projectPlanId: string, itemId: string)
	{
		const cmd = new c.DeleteProjectCapexItemCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId, itemId);
		this.$command(cmd, projectId);
	}

	invokeUpdateProjectCapexItemCommandV1(workspaceId: number, portfolioId: string, projectId: string, activePlanId: string,
		projectPlanId: string, capexAccountId: string, itemId: string, name: string, cost: number, acquisitionMonthIndex: number, salvageValue: number, usefulLifeInYears: number, depreciationMethod: string, denomination: string)
	{
		const cmd = new c.UpdateProjectCapexItemCommandV1(workspaceId, portfolioId, projectId, activePlanId, projectPlanId, capexAccountId, itemId, name, cost, acquisitionMonthIndex, salvageValue, usefulLifeInYears, depreciationMethod, denomination);
		this.$command(cmd, projectId);
	}


	invokeSetLifecycleProposalCommandV1(workspaceId: number, portfolioId: string, projectId: string)
	{
		const cmd = new c.SetLifecycleProposalCommandV1(workspaceId, portfolioId, projectId);
		this.$command(cmd, projectId);
	}

	invokeSetLifecycleQualifiedCommandV1(workspaceId: number, portfolioId: string, projectId: string)
	{
		const cmd = new c.SetLifecycleQualifiedCommandV1(workspaceId, portfolioId, projectId);
		this.$command(cmd, projectId);
	}

	invokeSetLifecycleRejectedCommandV1(workspaceId: number, portfolioId: string, projectId: string)
	{
		const cmd = new c.SetLifecycleRejectedCommandV1(workspaceId, portfolioId, projectId);
		this.$command(cmd, projectId);
	}


	invokeSetLifecycleScheduledCommandV1(workspaceId: number, portfolioId: string, projectId: string, startDate: MonthYear)
	{
		const cmd = new c.SetLifecycleScheduledCommandV1(workspaceId, portfolioId, projectId, startDate);
		this.$command(cmd, projectId);
	}

	invokeSetLifecycleInProgressCommandV1(workspaceId: number, portfolioId: string, projectId: string, startDate: MonthYear)
	{
		const cmd = new c.SetLifecycleInProgressCommandV1(workspaceId, portfolioId, projectId, startDate);
		this.$command(cmd, projectId);
	}

	invokeSetLifecyclePausedCommandV1(workspaceId: number, portfolioId: string, projectId: string)
	{
		const cmd = new c.SetLifecyclePausedCommandV1(workspaceId, portfolioId, projectId);
		this.$command(cmd, projectId);
	}

	invokeSetLifecycleResumedCommandV1(workspaceId: number, portfolioId: string, projectId: string)
	{
		const cmd = new c.SetLifecycleResumedCommandV1(workspaceId, portfolioId, projectId);
		this.$command(cmd, projectId);
	}

	invokeSetLifecycleTerminatedCommandV1(workspaceId: number, portfolioId: string, projectId: string)
	{
		const cmd = new c.SetLifecycleTerminatedCommandV1(workspaceId, portfolioId, projectId);
		this.$command(cmd, projectId);
	}

	invokeSetLifecycleCompletedCommandV1(workspaceId: number, portfolioId: string, projectId: string)
	{
		const cmd = new c.SetLifecycleCompletedCommandV1(workspaceId, portfolioId, projectId);
		this.$command(cmd, projectId);
	}
}
